/** Supervisor wallboard (M29 Phase 2, RPT-003): mirror of the console-facing part of backend `app/core/constants/wallboard.py`.
 *  `backend/tests/core/test_wallboard_mirror.py` keeps every export equal to its backend twin. */

/** Seconds between two snapshots on an open stream (the promise is at most `WALLBOARD_REFRESH_MAX_S`). */
export const WALLBOARD_REFRESH_S = 3 as const;

/** The console reads the snapshot this often while the stream is down. */
export const WALLBOARD_POLL_S = 5 as const;

/** `event:` name of a snapshot on `GET /v1/wallboard/events`. */
export const WALLBOARD_EVENT_NAME = "wallboard" as const;

/** A chat with an open SLA target due within this many seconds (or already late) counts as at risk. */
export const WALLBOARD_SLA_RISK_WINDOW_S = 300 as const;

/** Characters of a chat title / summary on the board. */
export const WALLBOARD_TEXT_MAX = 120 as const;
